import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const StateAdd = () => {
  const navigate = useNavigate();

  // Dummy countries
  const countries = ["India", "USA", "Canada"];

  const [formData, setFormData] = useState({
    state: "",
    country: "",
    status: "Active",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("State added:", formData);
    // TODO: Replace with API call to save state
    navigate("/state-master"); // redirect to state list
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Add State</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/state-master">State Master</Link>
                </li>
                <li className="breadcrumb-item active">Add State</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="row">
          <div className="col-md-6 offset-md-3">
            <div className="card">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {/* State Name */}
                  <div className="mb-3">
                    <label className="form-label">State Name</label>
                    <input
                      type="text"
                      name="state"
                      className="form-control"
                      value={formData.state}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Country Dropdown */}
                  <div className="mb-3">
                    <label className="form-label">Select Country</label>
                    <select
                      className="form-select"
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      required
                    >
                      <option value="">-- Select Country --</option>
                      {countries.map((c, i) => (
                        <option key={i} value={c}>
                          {c}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Status Dropdown */}
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select
                      className="form-select"
                      name="status"
                      value={formData.status}
                      onChange={handleChange}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>

                  {/* Buttons */}
                  <div className="text-end">
                    <button type="submit" className="btn btn-success me-2">
                      Save
                    </button>
                    <Link to="/state-list" className="btn btn-secondary">
                      Cancel
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StateAdd;
